function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Loader, TextInput } from '@mantine/core';
import Icon, { IconSizes } from './Icon';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
function SearchInput(_param) {
    var search = _param.search, setSearch = _param.setSearch, placeholder = _param.placeholder, autoFocus = _param.autoFocus, _param_isSearching = _param.isSearching, isSearching = _param_isSearching === void 0 ? false : _param_isSearching, props = _object_without_properties(_param, [
        "search",
        "setSearch",
        "placeholder",
        "autoFocus",
        "isSearching"
    ]);
    var isMobile = window.innerWidth < 768;
    return /*#__PURE__*/ _jsx(TextInput, _object_spread({
        id: "search",
        leftSectionPointerEvents: "none",
        "data-1p-ignore": true,
        placeholder: placeholder,
        value: search,
        variant: "outline",
        autoFocus: (autoFocus !== null && autoFocus !== void 0 ? autoFocus : false) && !isMobile,
        onChange: function(param) {
            var value = param.target.value;
            return setSearch(value);
        },
        leftSection: /*#__PURE__*/ _jsx(Icon, {
            size: IconSizes.SM,
            icon: faMagnifyingGlass
        }),
        rightSection: isSearching ? /*#__PURE__*/ _jsx(Loader, {
            size: "xs"
        }) : null
    }, props));
}
export default SearchInput;
